import { get } from 'lodash';
import { EventEmitter } from 'events';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { CHANGE_EVENT } from '../constants/AppConstants';
import SecurityDeviceConstants from '../constants/SecurityDeviceConstants';
import SecurityDeviceApiUtils from '../utils/SecurityDeviceApiUtils';
import compose from '../utils/functional/compose';

let _securityDevices = [];

const getStatusHistory = (device) => get(device, 'status_history', []);
const getStatus = (statusHistoryRecord) => get(statusHistoryRecord, 'status');
const isCurrentOrdered = (historyRecord) =>
  historyRecord.current && getStatus(historyRecord) === 'ORDERED';
const currentIsOrdered = compose(getStatusHistory, (x) =>
  x.some(isCurrentOrdered)
);

class SecurityDeviceStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  getSecurityDevices() {
    return _securityDevices;
  }

  getOrderedSecurityDevice() {
    return _securityDevices.find(currentIsOrdered);
  }

  hasOrderedToken() {
    return _securityDevices.some(currentIsOrdered);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  dispatcherCallback({ action: { actionType, data } }) {
    switch (actionType) {
      case SecurityDeviceConstants.GET_SECURITY_DEVICES:
        SecurityDeviceApiUtils.getSecurityDevices();
        break;
      case SecurityDeviceConstants.GET_SECURITY_DEVICES_SUCCESS:
        _securityDevices = data.security_devices;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new SecurityDeviceStore();
